import { getBooleanFromValue } from '@/global/utils/utils'

const TAB_KEY = 'basicInfo'
export default {
  name: 'basicInfo',

  computed: {
    basicInfoConfig () {
      return {
        title: this.$t('base/profile.basic_info'),
        key: TAB_KEY,
        formData: this.formData,
        onTabChange: () => {
          this.showMainEditButtons = true
        },
        editUpdate: (event) => {
          const { edit } = event || {}
          this.$set(this.disableTabs, 'idCards', edit)
          this.$set(this.disableTabs, 'documents', edit)
          this.$set(this.disableTabs, 'violations', edit)
        },
        tabContent: [
          {
            component: this.columnsContentComponent,
            title: this.$t('people/person.details'),
            showButtons: false,
            cardStyle: {
              maxWidth: '880px'
            },
            rows: [
              {
                type: 'fields',
                images: {
                  keys: [
                    'avatar'
                  ],
                  style: {
                    width: '120px',
                    height: '120px',
                    borderRadius: '70px'
                  },
                  default_image: '/public/base/images/default-avatar.png'
                },
                columnsCount: 2,
                disabled: !getBooleanFromValue(this.permissions?.canEdit),
                fields: [
                  {
                    key: 'first_name',
                    label: this.$t('base/user.first_name'),
                    placeholder: this.$t('base/profile.firstname_placeholder'),
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'last_name',
                    label: this.$t('base/user.last_name'),
                    placeholder: this.$t('base/profile.lastname_placeholder'),
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'record_number',
                    label: this.$t('people/person.record_number'),
                    placeholder: this.$t('people/person.enter_record_number'),
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'person_occupation',
                    label: this.$t('people/person.occupation'),
                    placeholder: this.$t('people/person.choose_occupation'),
                    type: 'autocomplete',
                    autocomplete_options: {
                      module: 'people',
                      route: 'person-occupation/autocomplete'
                    },
                    creatable: true,
                    editable: true,
                    visible: true
                  }
                ]
              }
            ]
          },
          // contact details
          {
            component: this.columnsContentComponent,
            title: this.$t('people/person.contact_details'),
            showButtons: false,
            cardStyle: {
              maxWidth: '880px'
            },
            rows: [
              {
                type: 'fields',
                columnsCount: 2,
                disabled: !getBooleanFromValue(this.permissions?.canEdit),
                fields: [
                  {
                    key: 'phone_number',
                    label: this.$t('people/person.phone_number'),
                    placeholder: this.$t('people/person.enter_phone_number'),
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'phone_number_2',
                    label: this.$t('people/person.phone_number_2'),
                    placeholder: this.$t('people/person.enter_phone_number_2'),
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'email',
                    label: this.$t('people/person.email'),
                    placeholder: this.$t('people/person.enter_email'),
                    creatable: true,
                    editable: true,
                    visible: true
                  }
                ]
              }
            ]
          },
          // other details
          {
            component: this.columnsContentComponent,
            title: this.$t('people/person.other_details'),
            showButtons: false,
            cardStyle: {
              maxWidth: '880px'
            },
            rows: [
              {
                type: 'fields',
                columnsCount: 2,
                disabled: !getBooleanFromValue(this.permissions?.canEdit),
                fields: [
                  {
                    key: 'group',
                    label: this.$t('people/person.group'),
                    placeholder: this.$t('people/person.choose_group'),
                    type: 'autocomplete',
                    autocomplete_options: {
                      module: 'people',
                      route: 'groups/autocomplete'
                    },
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'person_working_place',
                    label: this.$t('people/person.workplace'),
                    placeholder: this.$t('people/person.choose_working_place'),
                    type: 'autocomplete',
                    autocomplete_options: {
                      module: 'people',
                      route: 'working-place/autocomplete'
                    },
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'user',
                    label: this.$t('people/person.connect_with_user'),
                    type: 'autocomplete',
                    placeholder: this.$t('people/person.connect_with_user'),
                    autocomplete_options: {
                      module: 'base',
                      route: 'users/autocomplete'
                    },
                    creatable: true,
                    editable: true,
                    visible: true
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}
